export default __webpack_public_path__ + "static/wwu-3-f53fb3bca374d93e71e7fdbc9d1c852d.png";